const SET_AGENTS_LIST = 'SET_AGENTS_LIST';
const SET_NO_AGENTS = 'SET_NO_AGENTS';
const SET_SEARCH_BY_MAP = 'SET_SEARCH_BY_MAP';
const SET_SEARCH_ADDRESS = 'SET_SEARCH_ADDRESS';
const SET_LAST_SEARCH_ADDRESS = 'SET_LAST_SEARCH_ADDRESS';
const SET_SEARCH_ADDRESS_ERROR = 'SET_SEARCH_ADDRESS_ERROR';
const SET_SEARCH_NAME = 'SET_SEARCH_NAME';
const SET_LAST_SEARCH_NAME = 'SET_LAST_SEARCH_NAME';
const SET_SEARCH_NAME_ERROR = 'SET_SEARCH_NAME_ERROR';
const SET_SEARCH_ERROR = 'SET_SEARCH_ERROR';
const SET_AGENT = 'SET_AGENT';
const SET_HOVERED_AGENT = 'SET_HOVERED_AGENT';
const SET_AGENCY = 'SET_AGENCY';
const SET_WORK_TIME = 'SET_WORK_TIME';
const SET_AGENT_SOCIALS = 'SET_AGENT_SOCIALS';
const SET_AGENCY_WEBSITE_LIST = 'SET_AGENCY_WEBSITE_LIST'
const SET_DETAILS_OPEN = 'SET_DETAILS_OPEN';
const SET_MODAL_OPEN = 'SET_MODAL_OPEN';
const SET_MODAL_SUCCESS_OPEN = 'SET_MODAL_SUCCESS_OPEN';
const SET_ACTIVE_MARKER = 'SET_ACTIVE_MARKER';
const SET_MAP_CENTER = 'SET_MAP_CENTER';
const SET_MAP_ZOOM = 'SET_MAP_ZOOM';
const SET_LOADING = 'SET_LOADING';
const SET_SEARCH_COUNT = 'SET_SEARCH_COUNT';


const combineConst = {
    SET_AGENTS_LIST,
    SET_NO_AGENTS,
    SET_SEARCH_BY_MAP,
    SET_SEARCH_ADDRESS,
    SET_LAST_SEARCH_ADDRESS,
    SET_SEARCH_ADDRESS_ERROR,
    SET_SEARCH_NAME,
    SET_LAST_SEARCH_NAME,
    SET_SEARCH_NAME_ERROR,
    SET_SEARCH_ERROR,
    SET_AGENT,
    SET_HOVERED_AGENT,
    SET_AGENCY,
    SET_WORK_TIME,
    SET_AGENT_SOCIALS,
    SET_AGENCY_WEBSITE_LIST,
    SET_DETAILS_OPEN,
    SET_MODAL_OPEN,
    SET_MODAL_SUCCESS_OPEN,
    SET_ACTIVE_MARKER,
    SET_MAP_CENTER,
    SET_MAP_ZOOM,
    SET_LOADING,
    SET_SEARCH_COUNT,
};

export default combineConst;
